import { render } from "./LeaveManagement.vue?vue&type=template&id=0b934934&scoped=true"
import script from "./LeaveManagement.vue?vue&type=script&lang=js"
export * from "./LeaveManagement.vue?vue&type=script&lang=js"

import "./LeaveManagement.vue?vue&type=style&index=0&id=0b934934&scoped=true&lang=css"

import exportComponent from "C:\\ExactFloMarketingTool\\exactfloMarketingTool\\frontend\\marketingtool\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b934934"]])

export default __exports__